const sortDates = (dates: Date[]) => {
    const filtered = dates.sort();
    if(filtered.length <= 0) {
      return new Date();
    } else {
      return filtered[filtered.length - 1];
    }
}

export default sortDates;